import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import  secureLocalStorage  from  "react-secure-storage";
import { loginWith } from "../Component/User/UserContext";
import axios from 'axios';
export const client = async (endpoint, { body, ...customConfig } = {}) => {
  try
  {
    //checking token is expired or not...if expired then it will renew token..
   await renewtoken();
    const config = {
    method: body ? "POST" : "GET",
    url:endpoint,
    ...customConfig,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Authorization' :  'Bearer ' + secureLocalStorage.getItem("token"),
      'tokentype' :  secureLocalStorage.getItem("tokentype"),
      'uuid' :  secureLocalStorage.getItem("uuid"),
       'withCredentials': true,
      ...customConfig.headers,
    }
  };
  if (customConfig.method)
  {
    config.method= customConfig.method;
  }
  if (body) {
    config.body = JSON.stringify(body);
  }
  if (customConfig.token) {
    config.headers.Authorization = `Bearer ${customConfig.token}`;
  }
  if ( ['/api/validate-hr','/api/auth/local','/api/auth/local/register',
        '/api/sms/sendsms','/api/sms/validateotp','/api/validate/validateusercompany','/api/validate/registeruser'].filter(ep=> ep===endpoint ).length > 0)
  {
    config.headers.Authorization ='public';
  }
  if (customConfig.tokentype) {
    config.headers.tokentype = customConfig.tokentype
  }
  const res = await fetch(endpoint, config);
  const data = await res.json();
  if (res.status !== 200 ) {
      if (res.status !== 400)
      {
     // toast.error(res.statusText ? res.statusText : data?.error?.message ? data?.error?.message :  data?.message);
      }
      throw res;
     }
  return data;
}
catch (error)
    {
      //toast.error(error.message);
      console.log(error);
      throw error;
    }
};

async function  renewtoken() {
const token = secureLocalStorage.getItem("token");
  // Check if a token is present
const d = new Date();
const localTime = d.getTime();
const localOffset = d.getTimezoneOffset() * 60000;
const utc = localTime + localOffset;
const offset = 4; // UTC of Dubai is +04.00
const dubai = utc + (3600000 * offset);
const Dubaitime = new Date(dubai).getTime();
  //
  if (!token) {
    return false;
  }

  try {
    // Decode the access token
     const decodedToken = jwt_decode(token);
    // Check if the access token has expired
    if (decodedToken.exp < Dubaitime / 1000) {
         //get ren new token from backend..
         /*var config = {
          method: 'post',
          url: '/api/auth/local' ,
          headers: { 
            'Content-Type': 'application/json',
            'Accept' : 'application/json'
          },
          data: (secureLocalStorage.getItem('tokentype')===loginWith.Microsoft) ? 
              {identifier: secureLocalStorage.getItem("emailid") , password:  secureLocalStorage.getItem("emailid")} :   
              {identifier: '+' +  secureLocalStorage.getItem("mobileno") , password:  '+' + secureLocalStorage.getItem("mobileno")}
        };*/
         //
         var config ={ headers: { 
          'Content-Type': 'application/json',
          'Accept' : 'application/json',
          'token':secureLocalStorage.getItem("token"),
          'type':'refresh',
          identifier: (secureLocalStorage.getItem('tokentype')===loginWith.Microsoft) ? secureLocalStorage.getItem("emailid") : secureLocalStorage.getItem("mobileno")
        },
        url: '/api/validate/registeruser'
      }
        const refreshtoken= await axios(config)
                            .then(x=>{
                              if(x.data.error){toast.error(x.data.error);return true;}
                              secureLocalStorage.setItem("token",x.data.jwt);
                              return true;
                            })
                            .catch(error=>{
                              console.log(error);
                              return false;
                            })

      return refreshtoken;
    }
    else {
      return true;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
return true;
}
















